let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kPjDg")).then(() => parcelRequire('2T9Gp'));